import Phaser from 'phaser';

/**
 * BootScene — pierwsza scena, uruchamiana raz przy starcie gry.
 * Konfiguruje globalne rzeczy (skalowanie, resize handler) i przechodzi do Preload.
 *
 * NIE ładuje assetów — to robi PreloadScene.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  create(): void {
    // FIT skalowanie + resize na resize okna (mobile rotate / window resize).
    this.scale.scaleMode = Phaser.Scale.FIT;
    this.scale.autoCenter = Phaser.Scale.CENTER_BOTH;
    this.scale.refresh();

    // Przejdź do Preload.
    this.scene.start('PreloadScene');
  }
}
